"use client"

import {
	SidebarGroup,
	SidebarGroupContent,
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
} from "@/components/ui/sidebar"
import { ExternalLink, type LucideProps } from "lucide-react"

export function NavSecondary({
	items,
	...props
}: {
	items: {
		title: string
		url: string
		icon: React.ForwardRefExoticComponent<Omit<LucideProps, "ref"> & React.RefAttributes<SVGSVGElement>> | null
	}[]
} & React.ComponentPropsWithoutRef<typeof SidebarGroup>) {
	return (
		<SidebarGroup {...props}>
			<SidebarGroupContent>
				<SidebarMenu>
					{items.map((item) => (
						<SidebarMenuItem key={item.title} className="text-gray-800 dark:text-gray-200">
							<SidebarMenuButton asChild>
								<a href={item.url} target="_blank">
									{item.icon && <item.icon />}
									<span>{item.title}</span>
									<ExternalLink className="ml-auto" />
								</a>
							</SidebarMenuButton>
						</SidebarMenuItem>
					))}
				</SidebarMenu>
			</SidebarGroupContent>
		</SidebarGroup>
	)
}
